import React from 'react';
import styled, { css } from 'styled-components';
import { Button } from 'semantic-ui-react';

const SButton = styled(({ borderless, ...restProps }) => <Button {...restProps} />)`
  &&& {
    font-weight: 400;
  }
  ${props =>
    props.borderless &&
    css`
      &.ui.inverted.red.button,
      &.ui.inverted.red.buttons .button {
        box-shadow: none !important;
      }
    `};
`;

export { SButton };

export default SButton;
